import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SeguridadService } from '../../../services/seguridad/seguridad.service';
import { TiendaService } from '../../../services/tienda/tienda.service';

@Component({
  selector: 'app-pagos',
  templateUrl: './pagos.component.html',
  styleUrls: ['./pagos.component.scss'],
  standalone: false,
  providers: [MessageService]
})
export class PagosComponent implements OnInit {
  loadMenu: boolean = false;
  load: boolean = false;
  token: any = {};
  infoUser: any = {};
  infoEmpresa: Array<any> = [];
  /* Pago PAYU */
  pagoPendiente: number = 0;
  signature: String = "";
  tiendaData: any = {};
  reference: String = "";
  cadena: String = "";
  tax: number = 0;
  taxReturnBase: number = 0;


  checkoutForm = new FormGroup({
    name: new FormControl(''),
  });

  constructor(private form: FormBuilder, private http: HttpClient,
    private seguridad: SeguridadService, private tienda: TiendaService, private messsage: MessageService) { }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoEmpresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");

    // validar información de la tienda
    this.tienda.getInfoTienda(this.token.token, this.infoEmpresa[0].tiendaEmpleados[0].idTiendaNavigation.idTienda).subscribe((response) => {
      this.tiendaData = response as object;
      if (parseInt(this.tiendaData.pagoPendiente ?? 0) > 0) {
        this.pagoPendiente = parseInt(this.tiendaData.pagoPendiente ?? 0);
        this.reference = this.tiendaData.nombreTienda.replace('Ñ','N') + '-' + (Math.floor(Math.random() * 100) + 1);
        this.cadena = 'ngC2YUO2mZqlnA3n6721saaj51~927127~' + this.reference + '~' + this.pagoPendiente + '~COP~EFECTY,OTHERS_CASH,BANK_REFERENCED'
        this.taxReturnBase = this.pagoPendiente;
        this.tax = 0;
        // Obtener el SHA256
        this.seguridad.getSha256(this.cadena).subscribe((response1:any) => {
          this.signature = response1[0] as String;
        });
      }
      else
        this.messsage.add({ key: 'message', severity: 'info', summary: 'Información', detail: 'No dispone de facturas pendientes, cierre sesión e inicie nuevamente' })
    })

    if (parseInt(this.infoEmpresa[0].tiendaEmpleados[0].idTiendaNavigation.pagoPendiente ?? 0) > 0)
      this.pagoPendiente = parseInt(this.infoEmpresa[0].tiendaEmpleados[0].idTiendaNavigation.pagoPendiente ?? 0);

  }

  submit = () => {

  }

}
